import { useQuery } from '@tanstack/react-query';
import { API } from '@src/api/index.ts';

export const useProgramsAccessDurationsQuery = () => {
  return useQuery({
    queryKey: ['programsAccessDurations'],
    queryFn: async () => await API.programs.getAccessDurations(),
  });
};
